import {NgModule} from '@angular/core';
import {HTMLFragmentComponent} from './html-fragment.component';

@NgModule({
  declarations: HTMLFragmentModule.DECLARATIONS,
  exports: HTMLFragmentModule.DECLARATIONS
})
export class HTMLFragmentModule {
  public static readonly DECLARATIONS: any[] = [HTMLFragmentComponent];
}
